var _path, _polyline, _line;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCashFlow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 640,
    height: 360,
    viewBox: "0 0 640 360",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90 250 L150 220 L210 230 L270 190 L330 210 L390 160 L450 170 L510 140 L550 150 L550 270 L90 270 Z",
    fill: "#FDBA74",
    opacity: 0.6
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "90,250 150,220 210,230 270,190 330,210 390,160 450,170 510,140 550,150",
    fill: "none",
    stroke: "#F97316",
    strokeWidth: 4
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 90,
    y1: 270,
    x2: 550,
    y2: 270,
    stroke: "#E5E7EB",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashFlow);
export default __webpack_public_path__ + "static/media/cash-flow.325d42f3abcfe238ab2391ba1fb374fc.svg";
export { ForwardRef as ReactComponent };